import React, { useContext } from 'react';
import {ReactComponent as CloseSvg} from '../assets/close.svg';
import { context } from '../App';

export default function OverlayVideo() {
    const {setIsPlayClicked} = useContext(context);

    return (
        <div className="overlay-video" style={{width: "100vw", height: "100vh", position: "absolute", top: 0, left: 0, zIndex: 99, background: "#000000cc"}}>
            <iframe style={{width: "100%", height: "100%"}} src="https://player.vimeo.com/video/1002988274?h=be9288340f&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="ProInsight 3-Minute Intro">
            </iframe>
            <CloseSvg style={{position: "absolute", top: "1rem", right: "1rem", zIndex: 100, cursor: "pointer"}} onClick={()=>setIsPlayClicked(false)}/>
        </div>
    )
}